import { Component } from '@angular/core';
import { MensIntimateWashComponent } from '@components/consultation-request/upsells/mens-intimate-wash/mens-intimate-wash.component';

@Component({
  selector: 'app-mens-intimate-wash-yeast-infection',
  imports: [MensIntimateWashComponent],
  templateUrl: './mens-intimate-wash-yeast-infection.component.html',
})
export class MensIntimateWashYeastInfectionComponent {}
